import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=6b2718c2&scoped=true&lang=html&"
import script from "./groupInfo.vue?vue&type=script&lang=js&"
export * from "./groupInfo.vue?vue&type=script&lang=js&"
import style0 from "./groupInfo.vue?vue&type=style&index=0&id=6b2718c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2718c2",
  null
  
)

export default component.exports